module.exports = __webpack_public_path__ + "img/en-cofunded-by-the-eu_white.f57def51.png";